import UserSettings from './UserSettings';

export default UserSettings;
